import React, { useEffect } from "react";
import FlipCardSlider from "../../components/Slider/FlipCardSlider";
import ArticleContainer from "../../components/Article/ArticleContainer";
import ArticleHero from "../../components/Hero/ArticleHero";

const relatedBlogs = [
  {
    contentType: "BLOG",
    title: "Complimenting Fleet Modernization with Road Safety",
    description: "Shoora is leading the charge in transforming fleet operations by enhancing safety and operational efficiency through the Voluntary Vehicle-Fleet Modernization Programme (VVMP).",
    link: "/insights/blog/complimenting-fleet-modernization-with-road-safety",
    linkText: "Read article",
    thumbnail:
      "https://images.pexels.com/photos/11389692/pexels-photo-11389692.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  readTime: 10,
    },
  {
    contentType: "BLOG",
    title: "Envisioning the Future of Mobility with Shoora",
    description:
      "Shoora offers comprehensive fleet management solutions that track vehicle locations, monitor driver performance, optimise routes, and reduce fuel consumption.",
    thumbnail:
      "/images/thumbnails/14.jpeg",
    link: "/insights/blog/envisioning-the-future-of-mobility-with-shoora",
  readTime: 10,
  },
  {
    contentType: "BLOG",
    title: "Leverage AIS-140’s Mandate for Telematics Devices",
    description:
      "Shoora, a leader in advanced video telematics solutions , is committed to harnessing the potential of this mandate to create safer roads and smarter transportation systems.",
    thumbnail: "https://www.easyembedded.net/images/ais2.jpg",
    link: "/insights/blog/how-shoora-aims-to-leverage-ais-140s-mandate-for-telematics-devices-in-public-transportation-and-commercial-vehicles",
  readTime: 10,
  },
  {
    contentType: "BLOG",
    title: "Tackling Distracted Driving: Transforming Fleet Safety",
    description:
      "By adopting the Three Ts—Talk, Train, and Track, Shoora addresses distracted driving head-on, protecting lives and optimising operations.",
    thumbnail: "/images/thumbnails/3.jpeg",
    link: "/insights/blog/tackling-distracted-driving-transforming-fleet-safety",
  readTime: 10,
  },
  {
    contentType: "BLOG",
    title: "Truck Driver Safety Tips: A Guide to Protecting Lives on the Road",
    description:
      "Shoora, through its advanced video telematics solutions, is helping to curb these numbers and protect lives.",
    thumbnail:
      "https://images.pexels.com/photos/27946843/pexels-photo-27946843/free-photo-of-truck-rearview-mirror.jpeg?auto=compress&cs=tinysrgb&w=600",
    link: "/insights/blog/truck-driver-safety-tips-a-guide-to-protecting-lives-on-the-road",
  readTime: 10,
  },
  {
    contentType: "CUSTOMER STORY",
    title: "Shoora Life Savers Helped BLR Logistics Avert Over 7,500 Accidents",
    description:
      "Shoora is not just a service provider for BLR Logistics; they are a trusted safety partner.",
    thumbnail:
      "https://images.jdmagicbox.com/v2/comp/mumbai/26/022p1955726/catalogue/blr-logistics-india-ltd-goregaon-east-mumbai-transporters-for-all-india-3m98o5wutw.jpg",
    link: "/insights/customer-stories/how-shoora-life-savers-helped-blr-logistics-avert-over-7500-accidents",
  readTime: 10,
  },

  {
    contentType: "CUSTOMER STORY",
    title: "Kapoor Diesels Truck Achieves 1,60,200 Accident-Free Kilometres",
    description:
      "The integrated suite of technologies offered Kapoor Diesel enhanced safety, better fleet management, and measurable cost savings.",
    thumbnail: "/images/thumbnails/15.jpeg",
    link: "/insights/customer-stories/kapoor-diesel-fleet-achieves-60200-accident-free-kilometres-with-shooras-cutting-edge-video-telematics-solutions",
  readTime: 10,
  },
];
const data = {
  contentType: "Insider",
  title: "Industry Relations",
  description:
    "At Shoora, we are redefining industry standards by partnering with key stakeholders to deliver innovative fleet solutions, enhance safety, and drive operational efficiency across sectors.",
  author: "Shoora",
  createdOn: "26th Oct, 2024",
  imgsrc:
    "https://www.slalom.com/adobe/dynamicmedia/deliver/dm-aid--9dd9c6b8-7911-47d7-9fcb-77b374db4eb2/customer-love-landing.png?preferwebp=true&quality=85&width=1600",
  readTime: 10,
  content: `   <p>
        At Shoora, we are redefining industry standards by partnering with key
        stakeholders to deliver innovative fleet solutions, enhance safety, and
        drive operational efficiency across sectors.
      </p>

      <h2>Comprehensive Fleet Solutions</h2>
      <p>Shoora offers tailored solutions to address diverse industry needs:</p>
      <ul>
        <li>
          <strong>Passenger Vehicles:</strong> Real-time monitoring, advanced
          telematics, and driver behaviour analytics to ensure safety and
          optimise fleet performance.
        </li>
        <li>
          <strong>School Transportation:</strong> Compliance-driven solutions
          like CCTV systems, AI-powered alerts, and female wardens to meet
          safety mandates under Rule 222, NDMA, and POCSO guidelines.
        </li>
        <li>
          <strong>Airport Fleet Management:</strong> Streamlined operations for
          ground fleets with precise tracking, safety alerts, and optimised
          route planning.
        </li>
      </ul>

      <h2>Insurance Telematics</h2>
      <p>
        Shoora partners with insurers to leverage telematics data for
        <strong>risk profiling, premium optimization</strong>, and accident
        prevention. Our AI-driven insights empower insurers to reward safe
        driving behaviours and reduce claim costs through real-time incident
        analysis.
      </p>

      <h2>OEM Collaborations</h2>
      <p>
        Through strategic partnerships with Original Equipment Manufacturers
        (OEMs), Shoora integrates telematics and AI systems into new vehicle
        designs. These collaborations ensure factory-fitted solutions that
        enhance safety, compliance, and vehicle intelligence from day one.
      </p>

      <h2>Empowering Industries with Innovation</h2>
      <p>
        From public transportation to logistics, Shoora bridges industry gaps
        with cutting-edge technology. Our holistic solutions deliver safety,
        efficiency, and sustainability, enabling partners to thrive in an
        evolving mobility landscape.
        <br />
        <br />
        Together, we are shaping the future of transportation—safer, smarter,
        and more connected.
      </p>`,
};
const IndustryRelations = () => {
  useEffect(()=> {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  },[]);
  return (
    <>
      <ArticleHero
        contentType={data?.contentType}
        title={data?.title}
        createdOn={data?.createdOn}
        imgsrc="/images/about/bg8.webp"
      />
      <div className="bg-dark">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="#">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a href="#">Insights</a>
              </li>
              <li class="breadcrumb-item">
                <a href="#" className="text-capitalize">
                  {data?.contentType}s
                </a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                {data?.title}
              </li>
            </ol>
          </nav>
        </div>
      </div>

    

      <ArticleContainer data={data} />
      <hr className="border-3" style={{ borderColor: "var(--accent-color)" }} />
      <div
                className="stories-section section my-5"
                style={{ maxWidth: "100%" }}
            >
                <div className="container">
                    
                <FlipCardSlider data={relatedBlogs} title={"You may also like"}/>
                </div>
            </div>
    </>
  );
};

export default IndustryRelations;
